import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { UiConfirmModule } from "@youm-front/ui";
import {
  RoomAlertsEffects,
  RoomBrandBgEffects,
  RoomBrandCaptionLowerThirdEffects,
  RoomBrandEffects,
  RoomBrandLogoEffects,
  RoomBrandOverlayEffects,
  RoomLiveViewEffects,
  RoomLocalAudioStreamEffects,
  RoomLocalVideoStreamEffects,
  RoomRecordingEffects,
  RoomsListEffects,
  RoomsPastListEffects,
  RoomStageLayoutEffects,
  RoomStreamEffects
} from "./+state/effects";
import {
  RoomAccountFacade,
  RoomBrandBgFacade,
  RoomBrandCaptionLowerThirdFacade,
  RoomBrandFacade,
  RoomBrandLogoFacade,
  RoomBrandOverlayFacade,
  RoomContextFacade,
  RoomMixerFacade,
  RoomRecordingFacade,
  RoomsListFacade,
  RoomsPastListFacade,
  RoomStageLayoutFacade,
  RoomStreamFacade
} from "./+state/facades";
import {
  roomBrandBgReducer,
  roomBrandCaptionLowerThirdReducer,
  roomBrandLogoReducer,
  roomBrandOverlayReducer,
  roomBrandReducer,
  roomLocalStreamsReducer,
  roomMixerReducer,
  roomReducer,
  roomRemoteStreamsReducer,
  roomsListReducer,
  roomsPastListReducer,
  roomStageLayoutReducer,
  roomStreamReducer,
  ROOMS_LIST_FEATURE_KEY,
  ROOMS_PAST_LIST_FEATURE_KEY,
  ROOM_BRAND_BG_FEATURE_KEY,
  ROOM_BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY,
  ROOM_BRAND_FEATURE_KEY,
  ROOM_BRAND_LOGO_FEATURE_KEY,
  ROOM_BRAND_OVERLAY_FEATURE_KEY,
  ROOM_FEATURE_KEY,
  ROOM_LOCAL_STREAMS_FEATURE_KEY,
  ROOM_MIXER_FEATURE_KEY,
  ROOM_REMOTE_STREAMS_FEATURE_KEY,
  ROOM_STAGE_LAYOUT_FEATURE_KEY,
  ROOM_STREAM_FEATURE_KEY
} from "./+state/reducers";
import {
  LocalCamMicStreamService,
  RoomBrandBgService,
  RoomBrandCaptionLowerThirdService,
  RoomBrandLogoService,
  RoomBrandOverlayService,
  RoomBrandService,
  RoomInvitationFirstService,
  RoomMixerService,
  RoomRecordingService,
  RoomsListService,
  RoomsPastListService,
  RoomStageLayoutService,
  RoomStreamService
} from "./+state/services";

@NgModule({
  imports: [
    CommonModule,
    UiConfirmModule,
    StoreModule.forFeature(ROOM_BRAND_FEATURE_KEY, roomBrandReducer),
    StoreModule.forFeature(ROOM_BRAND_BG_FEATURE_KEY, roomBrandBgReducer),
    StoreModule.forFeature(
      ROOM_BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY,
      roomBrandCaptionLowerThirdReducer
    ),
    StoreModule.forFeature(ROOM_BRAND_LOGO_FEATURE_KEY, roomBrandLogoReducer),
    StoreModule.forFeature(
      ROOM_BRAND_OVERLAY_FEATURE_KEY,
      roomBrandOverlayReducer
    ),
    StoreModule.forFeature(ROOM_MIXER_FEATURE_KEY, roomMixerReducer),
    StoreModule.forFeature(
      ROOM_STAGE_LAYOUT_FEATURE_KEY,
      roomStageLayoutReducer
    ),
    StoreModule.forFeature(ROOM_STREAM_FEATURE_KEY, roomStreamReducer),
    StoreModule.forFeature(ROOMS_LIST_FEATURE_KEY, roomsListReducer),
    StoreModule.forFeature(ROOMS_PAST_LIST_FEATURE_KEY, roomsPastListReducer),
    StoreModule.forFeature(
      ROOM_LOCAL_STREAMS_FEATURE_KEY,
      roomLocalStreamsReducer
    ),
    StoreModule.forFeature(
      ROOM_REMOTE_STREAMS_FEATURE_KEY,
      roomRemoteStreamsReducer
    ),
    StoreModule.forFeature(ROOM_FEATURE_KEY, roomReducer),
    EffectsModule.forFeature([
      RoomAlertsEffects,
      RoomBrandBgEffects,
      RoomBrandCaptionLowerThirdEffects,
      RoomBrandLogoEffects,
      RoomBrandOverlayEffects,
      RoomBrandEffects,
      RoomLiveViewEffects,
      RoomLocalAudioStreamEffects,
      RoomLocalVideoStreamEffects,
      RoomRecordingEffects,
      RoomStageLayoutEffects,
      RoomStreamEffects,
      RoomsListEffects,
      RoomsPastListEffects
    ])
  ],
  providers: [
    RoomAccountFacade,
    RoomBrandBgFacade,
    RoomBrandCaptionLowerThirdFacade,
    RoomBrandFacade,
    RoomBrandLogoFacade,
    RoomBrandOverlayFacade,
    RoomContextFacade,
    RoomMixerFacade,
    RoomRecordingFacade,
    RoomStageLayoutFacade,
    RoomStreamFacade,
    RoomsListFacade,
    RoomsPastListFacade,
    RoomBrandService,
    RoomBrandBgService,
    RoomBrandCaptionLowerThirdService,
    RoomBrandLogoService,
    RoomBrandOverlayService,
    RoomRecordingService,
    RoomStageLayoutService,
    RoomStreamService,
    RoomsListService,
    RoomsPastListService,
    LocalCamMicStreamService,
    RoomInvitationFirstService,
    RoomMixerService
  ]
})
export class RoomDataAccessModule {}
